import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className="min-h-screen flex items-center justify-center bg-canvas p-4">
          <div className="w-full max-w-md bg-surface rounded-2xl shadow-lg p-8 text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-danger-soft rounded-full flex items-center justify-center">
              <span className="text-danger text-2xl font-bold">!</span>
            </div>
            <h2 className="text-xl font-bold text-ink mb-2">
              Error inesperado
            </h2>
            <p className="text-ink-2 mb-6">
              Ha ocurrido un error. Por favor, intenta de nuevo.
            </p>
            {this.state.error && (
              <pre className="mb-6 p-3 bg-surface-2 rounded-lg text-xs text-left text-ink-2 overflow-auto max-h-32">
                {this.state.error.message}
              </pre>
            )}
            <button
              onClick={this.handleRetry}
              className="px-6 py-3 bg-brand text-white rounded-xl font-semibold hover:bg-brand-2 transition-colors"
            >
              Reintentar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
